module.exports = __webpack_public_path__ + "img/emoticon-csat-1-off.fa474cc8.svg";